export default defineNuxtRouteMiddleware((to, from) => {
  const localePath = useLocalePath();
  const userStore = useUserStore();
  if (to.path.includes("user-portal")) {
    if (userStore.isLoggedIn) return;
    return navigateTo(localePath(`/loading?auth=true&redirect=${to.fullPath}`));
  } else if (to.path.includes("collection")) {
    if (userStore.isLoggedIn) return;
    return navigateTo(localePath(`/loading?auth=true&redirect=${to.fullPath}`));
  } else if (to.path.includes("collectible") && to.query.forceLogin) {
    if (userStore.isLoggedIn) return;
    return navigateTo(localePath(`/loading?auth=true&redirect=${to.fullPath}`));
  }
});
